// #356: what a program keeps of the model that wrote it. The focus, and the
// choices of the wizard: with them the next-block sheet rebuilds the rows of a
// new block at another focus (programModelBlock.ts). A program made by hand,
// or before #356, has neither. The levels and the minutes live here, not in
// programModel.ts, because Program reads them and programModel.ts imports
// what imports schemas/program.ts. Keep free of React and any UI import.
import { z } from "zod";

import { ProgramFocus } from "./programV3.js";
import { slugString } from "./slug.js";

export const MODEL_LEVELS = ["beginner", "intermediate", "advanced"] as const;
export const ModelLevel = z.enum(MODEL_LEVELS);
export type ModelLevel = z.infer<typeof ModelLevel>;

/** 45 min drops the optional rows and a set of each accessory; 60 drops the
 *  optional rows; 75 keeps everything (§15 row 33). */
export const SESSION_MINUTES = [45, 60, 75] as const;
export type SessionMinutes = (typeof SESSION_MINUTES)[number];

/** A model has at most 7 days of 20 rows. */
const MAX_PICKS = 140;

export const ProgramOrigin = z.object({
  modelId: z.string().min(1).max(64),
  level: ModelLevel,
  minutes: z.literal(SESSION_MINUTES),
  /** The exercise picked for a row, by row id; a row not here has its default. */
  picks: z.record(slugString(64), slugString(64)).refine((p) => Object.keys(p).length <= MAX_PICKS, {
    message: "too_many_picks",
  }),
});
export type ProgramOrigin = z.infer<typeof ProgramOrigin>;

/** The two fields a model writes on a Program, spread into its schema. */
export const programModelFields = {
  focus: ProgramFocus.optional(),
  origin: ProgramOrigin.optional(),
};
